var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm.fromEventPage ? _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'PartnerMarketingEventList'
      }
    }
  }, [_vm._v("點數/商品兌換活動")]) : _vm._e(), _vm.fromEventPage && _vm.parentEvent ? _c('b-breadcrumb-item', {
    on: {
      "click": _vm.backToEventPlans
    }
  }, [_vm._v(_vm._s(_vm.parentEvent.name) + " - 兌換活動方案")]) : _vm._e(), !_vm.fromEventPage ? _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'PartnerMarketingPlanList'
      }
    }
  }, [_vm._v("兌換活動方案")]) : _vm._e(), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? '編輯' : '新增') + "方案")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? '編輯' : '新增') + "兌換活動方案 ")])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading
    }
  }, [_c('b-form', {
    ref: "formRef",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動名稱",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "state": _vm.errors.name ? false : null,
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _vm.errors.name ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "點數/商品兌換活動",
      "label-for": "partner_marketing_event_id"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.events,
      "disabled": _vm.isView || _vm.isEdit || _vm.isLoading || _vm.fromEventPage
    },
    on: {
      "input": _vm.setEventId
    },
    model: {
      value: _vm.selectedEvent,
      callback: function callback($$v) {
        _vm.selectedEvent = $$v;
      },
      expression: "selectedEvent"
    }
  }), _vm.errors.partner_marketing_event_id ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.partner_marketing_event_id))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "狀態",
      "label-for": "status"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.statusOptions,
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.status,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }), _vm.errors.status ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.status))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "上架時間",
      "label-for": "start_at"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isView || _vm.isLoading,
      "clear-button": ""
    },
    model: {
      value: _vm.start_at,
      callback: function callback($$v) {
        _vm.start_at = $$v;
      },
      expression: "start_at"
    }
  })], 1), _vm.errors.start_at ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.start_at))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下架時間",
      "label-for": "end_at"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isView || _vm.isLoading,
      "clear-button": "",
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.end_at,
      callback: function callback($$v) {
        _vm.end_at = $$v;
      },
      expression: "end_at"
    }
  })], 1), _vm.errors.end_at ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.end_at))]) : _vm._e(), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.endAtValidationState
    }
  }, [_vm._v(_vm._s(_vm.endAtValidationMessage))])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "兌換開始日",
      "label-for": "exchange_start_at"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isView || _vm.isLoading,
      "clear-button": ""
    },
    model: {
      value: _vm.exchange_start_at,
      callback: function callback($$v) {
        _vm.exchange_start_at = $$v;
      },
      expression: "exchange_start_at"
    }
  })], 1), _vm.errors.exchange_start_at ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.exchange_start_at))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "兌換截止日",
      "label-for": "exchange_end_at"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isView || _vm.isLoading,
      "clear-button": "",
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.exchange_end_at,
      callback: function callback($$v) {
        _vm.exchange_end_at = $$v;
      },
      expression: "exchange_end_at"
    }
  })], 1), _vm.errors.exchange_end_at ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.exchange_end_at))]) : _vm._e(), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.exchangeEndAtValidationState
    }
  }, [_vm._v(_vm._s(_vm.exchangeEndAtValidationMessage))])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "序號使用開始時間",
      "label-for": "code_start_at"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isView || _vm.isLoading,
      "clear-button": ""
    },
    model: {
      value: _vm.code_start_at,
      callback: function callback($$v) {
        _vm.code_start_at = $$v;
      },
      expression: "code_start_at"
    }
  })], 1), _vm.errors.code_start_at ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.code_start_at))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "序號使用結束時間",
      "label-for": "code_end_at"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isView || _vm.isLoading,
      "clear-button": "",
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.code_end_at,
      callback: function callback($$v) {
        _vm.code_end_at = $$v;
      },
      expression: "code_end_at"
    }
  })], 1), _vm.errors.code_end_at ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.code_end_at))]) : _vm._e(), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.codeEndAtValidationState
    }
  }, [_vm._v(_vm._s(_vm.codeEndAtValidationMessage))])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "POYA點數",
      "label-for": "source_points"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "source_points",
      "type": "number",
      "state": _vm.errors.source_points ? false : null,
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.source_points,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "source_points", $$v);
      },
      expression: "form.source_points"
    }
  }), _vm.errors.source_points ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.source_points))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "兌換數量",
      "label-for": "target_points"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "target_points",
      "type": "number",
      "state": _vm.errors.target_points ? false : null,
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.target_points,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "target_points", $$v);
      },
      expression: "form.target_points"
    }
  }), _vm.errors.target_points ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.target_points))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "兌換單位",
      "label-for": "target_unit"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "target_unit",
      "state": _vm.errors.target_unit ? false : null,
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.target_unit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "target_unit", $$v);
      },
      expression: "form.target_unit"
    }
  }), _vm.errors.target_unit ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.target_unit))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人兌換總組數上限",
      "label-for": "per_user_exchange_limit"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "per_user_exchange_limit",
      "type": "number",
      "state": _vm.errors.per_user_exchange_limit ? false : null,
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.per_user_exchange_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "per_user_exchange_limit", $$v);
      },
      expression: "form.per_user_exchange_limit"
    }
  }), _vm.errors.per_user_exchange_limit ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.per_user_exchange_limit))]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "排序",
      "label-for": "sort"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "sort",
      "type": "number",
      "placeholder": "排序為必填",
      "state": _vm.errors.sort ? false : null,
      "disabled": _vm.isView || _vm.isLoading
    },
    model: {
      value: _vm.form.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sort", $$v);
      },
      expression: "form.sort"
    }
  }), _vm.errors.sort ? _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.sort))]) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBackOrList
    }
  }, [_vm._v("返回")]), !_vm.isView ? _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success"
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }